import { inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  type NavigationExtras,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { AuthUserService } from './auth-user.service';

@Injectable({
  providedIn: 'root',
})
export class SuperAdminGuard {
  private authUserService = inject(AuthUserService);
  private router = inject(Router);

  constructor() {
    this.authUserService.authInit();
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.authUserService.userOrgObj.pipe(
      take(1),
      map((userOrgObj) => {
        const authenticated = !!userOrgObj;
        if (!authenticated) {
          // https://www.thepolyglotdeveloper.com/2016/10/passing-complex-data-angular-2-router-nativescript/
          const navigationExtras: NavigationExtras = {
            queryParams: { redirect: state.url },
          };
          this.router.navigate(['/login'], navigationExtras);
          return false;
        } else if (authenticated && !userOrgObj.superAdmins) {
          // Note we assume that isSuperAdmin can only be attached to the logged
          // in user, not via membership serve permission error page
          this.router.navigate(['/unauthorized']);
          return false;
        } else {
          return true;
        }
      })
    );
  }
}
